import { styled } from "../../../styles";
import { FilterGroup, StatsGrid } from "../shared/AdminPage.styles";

/**
 * Styles local to the Scheduled Jobs (Quartz) page. Generic admin chrome
 * lives in `shared/AdminPage.styles.ts`.
 */

/**
 * Second line of the filter bar: the seven selects, each taking an equal
 * share of the row and wrapping on narrow screens. Without a basis the antd
 * select sizes itself to its "All" text and every field ends up a stub.
 */
export const FilterRow = styled("div", {
  flexBasis: "100%",
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
});

/** One select and its label inside `FilterRow`. */
export const FilterField = styled(FilterGroup, {
  flex: "1 1 150px",
  minWidth: "150px",
});

/**
 * Scheduler facts on the right of the page title: name, region, snapshot
 * time. Muted and single-line; the instance id lives in the title attribute
 * because it is long and rarely needed.
 */
export const HeaderMeta = styled("span", {
  fontSize: "13px",
  color: "$gray-80",
  fontFamily: "$openSans",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "60%",
});

/**
 * The stat cards stretched across the full row. The shared grid uses
 * `auto-fill`, which keeps an empty track on the right when five cards do
 * not divide the width; `auto-fit` collapses it so the cards fill the space.
 */
export const StatsRow = styled(StatsGrid, {
  gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
  marginBottom: 0,
});

/** Label/value pairs in the detail modal, several to a row. */
export const DetailGrid = styled("div", {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "12px 24px",
});

export const DetailSectionTitle = styled("h3", {
  margin: "8px 0 0",
  fontSize: "13px",
  fontWeight: "600",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "$gray-80",
  fontFamily: "$openSans",
});

export const WarningList = styled("ul", {
  margin: 0,
  paddingLeft: "18px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const WardList = styled("ul", {
  listStyle: "none",
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const WardListItem = styled("li", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "12px",
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid $gray-30",
  fontSize: "13px",
  fontFamily: "$openSans",
  color: "$charcoal",

  "& span": {
    color: "$gray-80",
  },
});

/** Small count chip in the Warnings column. */
export const WarningCount = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "22px",
  height: "22px",
  padding: "0 6px",
  borderRadius: "11px",
  fontSize: "12px",
  fontWeight: "600",
  fontFamily: "$openSans",
  backgroundColor: "$warning-lightest",
  color: "$warning-dark",
  border: "1px solid $warning",
});

/** Muted second line under a cell's main text. */
export const CellSubtext = styled("span", {
  display: "block",
  fontSize: "12px",
  color: "$gray-80",
  fontFamily: "$openSans",
});
